import { QueryClient } from '@tanstack/react-query'
import { cardFeedsQueryKeys } from 'src/queries/queries.constants'

export interface CardFeedPusherPayload {
  id: string
  action: string
}

export const invalidateCardFeedQueriesFromPusher = (
  queryClient: QueryClient,
  organizationId: string | undefined,
  data: CardFeedPusherPayload,
): void => {
  if (organizationId === undefined) return

  void queryClient.invalidateQueries({
    queryKey: cardFeedsQueryKeys.list(organizationId),
  })
  void queryClient.invalidateQueries({
    queryKey: cardFeedsQueryKeys.detail(organizationId, data.id),
  })
  void queryClient.invalidateQueries({
    queryKey: cardFeedsQueryKeys.cards(data.id),
  })
}
